(() => {
/**
 * AASP Slider — Vanilla JS
 * Sem dependências externas.
 */ (function() {
    'use strict';
    function initSlider(block) {
        const slides = Array.from(block.querySelectorAll('.aasp-slide'));
        const dots = Array.from(block.querySelectorAll('.aasp-slider-dot'));
        const btnPrev = block.querySelector('.aasp-slider-arrow--prev');
        const btnNext = block.querySelector('.aasp-slider-arrow--next');
        if (slides.length <= 1) {
            if (btnPrev) btnPrev.style.visibility = 'hidden';
            if (btnNext) btnNext.style.visibility = 'hidden';
            return;
        }
        let current = 0;
        function goTo(index) {
            const total = slides.length;
            current = (index + total) % total;
            slides.forEach((slide, i)=>{
                const active = i === current;
                slide.classList.toggle('is-active', active);
                slide.setAttribute('aria-hidden', active ? 'false' : 'true');
            });
            dots.forEach((dot, i)=>{
                const active = i === current;
                dot.classList.toggle('is-active', active);
                dot.setAttribute('aria-selected', active ? 'true' : 'false');
            });
        }
        btnPrev.addEventListener('click', ()=>goTo(current - 1));
        btnNext.addEventListener('click', ()=>goTo(current + 1));
        dots.forEach((dot, i)=>{
            dot.addEventListener('click', ()=>goTo(i));
        });
        let touchStartX = 0;
        block.addEventListener('touchstart', (e)=>{
            touchStartX = e.changedTouches[0].clientX;
        }, {
            passive: true
        });
        block.addEventListener('touchend', (e)=>{
            const diff = touchStartX - e.changedTouches[0].clientX;
            if (Math.abs(diff) < 40) return;
            goTo(diff > 0 ? current + 1 : current - 1);
        }, {
            passive: true
        });
    }
    function init() {
        const blocks = document.querySelectorAll('.aasp-slider-block');
        blocks.forEach(initSlider);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();



})();
//# sourceMappingURL=index.js.map
